export default __webpack_public_path__ + "static/media/avatarB5.ed6488aa.png";